import { OptionType } from '@fullstory/components';
import { SegmentSettings } from '@fullstory/proto/fs/services/search-settings/visualizationsettings';
import { SegmentDetail } from '@fullstory/proto/fs/services/dx-objects';
import { AppState, segmentsSelectors } from '@fullstory/redux';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

const { makeGetSegmentsFromSettings } = segmentsSelectors;

export function useSegmentDetails(segmentSettings: SegmentSettings[]) {
  const getSegmentsFromSettings = useMemo(() => makeGetSegmentsFromSettings(), []);

  return useSelector((state: AppState) => getSegmentsFromSettings(state, segmentSettings));
}

export const useSegmentSelectOptions = (segmentDetails: SegmentDetail[]): OptionType<string>[] =>
  useMemo(
    () =>
      segmentDetails.map(segment => ({
        key: segment.segment!.segment!.id,
        value: segment.segment!.segment!.id,
        label: segment.segment!.segment!.name,
      })),
    [segmentDetails],
  );
